import React from 'react';
import { noteColors } from './constants';

export const ColorPicker = ({ value, onChange, language = 'de' }) => (
  <div className="flex gap-2 flex-wrap" role="radiogroup" aria-label={language === 'de' ? 'Farbe auswählen' : 'Select color'}>
    {Object.entries(noteColors).map(([colorKey, colorValue]) => (
      <button
        key={colorKey}
        type="button"
        role="radio"
        aria-checked={value === colorKey}
        onClick={() => onChange(colorKey)}
        className={`w-8 h-8 rounded-full ${colorValue.bg} ${colorValue.border} border-2 transition-all ${
          value === colorKey ? `ring-2 ${colorValue.ring} ring-offset-2` : 'hover:scale-110'
        }`}
        title={colorValue.label[language]}
        data-testid={`color-picker-${colorKey}`}
      />
    ))}
  </div>
);

export default ColorPicker;
